import { Dispatch, Action } from 'redux'
import { TaskStatusButtonsInputFieldMapDispatchReturnType } from './types/TaskStatusButtonsInputFieldMapDispatchReturnType'

export const TaskStatusButtonsInputFieldMapDispatch = (
  _dispatch: Dispatch<Action>
): TaskStatusButtonsInputFieldMapDispatchReturnType => {
  return {}
}
